/**
 * Вход клиента по персональному коду и просмотр привязанной истории.
 */

import { z } from "zod";
import { accessGrantStatusSchema, accessTypeSchema } from "./access-grants";
import { apiSuccessSchema } from "./envelope";
import { projectStatusSchema, projectStepSchema, projectStepTypeSchema } from "./projects";

export const clientAccessRequestSchema = z.object({
  personalCode: z.string().trim().length(8),
  captchaToken: z.string().optional(),
});
export type ClientAccessRequest = z.infer<typeof clientAccessRequestSchema>;

export const clientLoginRequestSchema = z.object({
  email: z.string().trim().email().max(255),
  password: z.string().min(1).max(256),
  captchaToken: z.string().optional(),
});
export type ClientLoginRequest = z.infer<typeof clientLoginRequestSchema>;

export const clientAccessClientSchema = z.object({
  id: z.string().uuid(),
  personalCode: z.string().length(8),
  company: z.string().min(1).max(255),
  position: z.string().min(1).max(255),
  fullName: z.string().min(1).max(255),
  email: z.string().email(),
  phone: z.string().min(1).max(64),
  region: z.string().max(255).nullable(),
  deliveryObject: z.string().max(512).nullable(),
});
export type ClientAccessClient = z.infer<typeof clientAccessClientSchema>;

export const clientAccessProjectSchema = z.object({
  id: z.string().uuid(),
  status: projectStatusSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  currentSteps: z.array(projectStepTypeSchema),
  steps: z.array(projectStepSchema),
});
export type ClientAccessProject = z.infer<typeof clientAccessProjectSchema>;

export const clientAccessGrantSchema = z.object({
  accessType: accessTypeSchema,
  status: accessGrantStatusSchema,
});
export type ClientAccessGrant = z.infer<typeof clientAccessGrantSchema>;

export const clientAccessResultSchema = z.object({
  client: clientAccessClientSchema,
  projects: z.array(clientAccessProjectSchema),
  grants: z.array(clientAccessGrantSchema),
});
export type ClientAccessResult = z.infer<typeof clientAccessResultSchema>;

export const clientAccessResponseSchema = apiSuccessSchema(clientAccessResultSchema);

export const CLIENT_ACCESS_ERROR_CODES = {
  NOT_FOUND: "CLIENT_ACCESS_NOT_FOUND",
  INVALID_CREDENTIALS: "CLIENT_ACCESS_INVALID_CREDENTIALS",
} as const;
export type ClientAccessErrorCode =
  (typeof CLIENT_ACCESS_ERROR_CODES)[keyof typeof CLIENT_ACCESS_ERROR_CODES];
